import React, { InputHTMLAttributes } from 'react';
import Select from './Select';
import { useFormik } from 'formik';
import { SelectOption } from '@/src/types/select-option';
import { isRequiredField } from '@/src/lib/utils/form-helpers';
import * as Yup from 'yup';

export interface FormikSelectProps extends InputHTMLAttributes<HTMLSelectElement> {
  options: Array<SelectOption>;
  placeholder: string;
  label: string;
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: ReturnType<typeof useFormik<any>>;
  testId?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formikValidationSchema: Yup.ObjectSchema<any>;
}

export default function FormikSelect({
  name,
  formik,
  formikValidationSchema,
  required,
  placeholder,
  ...otherProps
}: FormikSelectProps) {
  const isRequired = required || isRequiredField(formikValidationSchema, name);

  return (
    <Select
      name={name}
      value={formik.values[name]}
      error={formik.errors[name] && formik.touched[name] ? String(formik.errors[name]) : undefined}
      onBlur={formik.handleBlur}
      required={isRequired}
      aria-required={isRequired}
      placeholder={placeholder}
      onSelectionChangeHook={(option: SelectOption) => formik.setFieldValue(name, option.value)}
      {...otherProps}
    />
  );
}
